/**
 * @deprecated Use formatValue(value, 'string:plural,{singular}') to pluralize a string.
 */
export function plural(
  value: number | any[] | undefined,
  word: string,
  includeValue = true,
): string {
  const words = word.split(/\W/)

  /**
   * Support more than 2 words, return all words
   * And pluralized the last word
   */
  if (words.length > 2) {
    const some = words.pop()
    const rest = words.join(' ')
    return `${rest} ${some}s`
  }

  const [one = '', some] = words
  // make sure one doesn't end with 's'
  const plural = some || `${one.replace(/s$/, '')}s`
  const num = Array.isArray(value)
    ? value.length
    : value
  const output = num === 1
    ? one
    : plural
  return includeValue
    ? `${num} ${output}`
    : output ?? ''
}

/**
 * @deprecated Use formatValue(value, 'string:title') to convert a string to title case.
 */
export function toTitleCase(text: string): string {
  return text
    .trim()
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/\s+/g, ' ')
    .replace(/\b(\w)/g, (str: string) => str.toUpperCase())
    .trim()
}
